import "./SiteActivation.html";
import "./SiteActivation.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteActivationComponentController from "./SiteActivationComponentController";

export default class SiteActivationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = SiteActivationComponentController;
        this.templateUrl = "/App/Components/Site/Activation/SiteActivation.html";
    }
}

module("mmManagePortal").component("irSiteActivation", new SiteActivationComponent());
